import { createSlice } from '@reduxjs/toolkit';
// types
import { SnackbarProps } from 'types/snackbar';

const initialState: SnackbarProps = {
  action: false,
  open: false,
  message: 'Note archived',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  variant: 'default',
  alert: {
    variant: 'filled',
    severity: 'success',
  },
  transition: 'Fade',
  close: true,
  actionButton: false,
  autoHideDuration: 4000,
  customAction: undefined,
  navigateTo: undefined,
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const snackbar = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    openSnackbar(state, action: { payload: Partial<SnackbarProps> }) {
      const {
        open,
        message,
        anchorOrigin,
        variant,
        alert,
        transition,
        close,
        actionButton,
        autoHideDuration,
        customAction,
        navigateTo,
      } = action.payload;

      state.action = !state.action;
      state.open = open || initialState.open;
      state.message = message || initialState.message;
      state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
      state.variant = variant || initialState.variant;
      state.alert = {
        color: alert?.color || initialState.alert.color,
        variant: alert?.variant || initialState.alert.variant,
        severity: alert?.severity || initialState.alert.severity,
      };
      state.transition = transition || initialState.transition;
      state.close = close === false ? close : initialState.close;
      state.actionButton = actionButton || initialState.actionButton;
      state.autoHideDuration =
        autoHideDuration !== undefined
          ? autoHideDuration
          : initialState.autoHideDuration;
      if (navigateTo !== undefined)
        state.autoHideDuration = initialState.autoHideDuration * 2;
      state.customAction = customAction || initialState.customAction;
      state.navigateTo = navigateTo || initialState.navigateTo;
    },

    closeSnackbar(state) {
      state.open = false;
    },
  },
});

export default snackbar.reducer;

export const { closeSnackbar, openSnackbar } = snackbar.actions;
